import { createFileRoute, redirect } from '@tanstack/react-router';

type LegacyOverviewBeforeLoadArgs = {
  params: {
    loopId: number;
    org: string;
  };
};

export const legacyOverviewBeforeLoad = async ({ params }: LegacyOverviewBeforeLoadArgs) => {
  throw redirect({
    to: '/org/$org/loop/$loopId/strategy',
    params,
    search: true,
    replace: true,
  });
};

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/overview/')({
  beforeLoad: legacyOverviewBeforeLoad,
});
